export const base_url = "https://verimedramja.pythonanywhere.com/verimed";
